import React from 'react';
import { useTranslation } from 'react-i18next';

export function BackEndCards(props) {
  const { projectKey, image, link } = props;
  const { t } = useTranslation();
  const name = t(`projetos.${projectKey}.name`);
  const description = t(`projetos.${projectKey}.description`);
  return (
    <article className="flex h-full min-w-0 flex-col">
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="group flex h-full min-h-0 flex-col rounded-2xl border border-white/10 bg-white/[0.06] p-4 shadow-lg shadow-black/10 transition hover:border-orange-500/50 hover:bg-white/[0.09] sm:p-5"
      >
        <h3 className="mb-3 break-words text-center text-lg font-semibold leading-tight text-white sm:text-xl">
          {name}
        </h3>
        <div className="flex shrink-0 justify-center">
          <img
            className="aspect-square w-full max-w-[260px] rounded-2xl object-cover p-1 ring-1 ring-white/10 transition duration-300 group-hover:scale-[1.02] group-hover:ring-2 group-hover:ring-orange-500/60"
            src={image}
            alt={name}
          />
        </div>
        <p className="mt-4 min-h-0 flex-1 text-left text-sm leading-relaxed text-gray-300 sm:mt-5 sm:text-[0.9375rem]">
          {description}
        </p>
      </a>
    </article>
  );
}

export default BackEndCards;
